"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandBeta = exports.brandWordmark = exports.brandColors = exports.brandMark = exports.soon = exports.motion = exports.typography = exports.radii = exports.spacing = exports.fonts = exports.colors = exports.readingSheetTheme = exports.defaultTheme = exports.themes = void 0;
const dark = {
    bg: '#100c08',
    bgRaised: '#17120c',
    surface: '#1c1710',
    line: '#352c1d',
    text: '#f5ecdb',
    muted: '#ac9f86',
    mutedDim: '#8f836c',
    accent: '#e8b04a',
    accentSoft: '#f6d98f',
    accentDeep: '#8a6a28',
    fill: '#e8b04a',
    fillSoft: '#f6d98f',
    onFill: '#1a1204',
    fillGradient: 'none',
    fillRing: 'transparent',
    fillGlow: 'transparent',
    ok: '#6fae8a',
    danger: '#d9674f',
    glow: 'rgba(232, 176, 74, 0.16)',
    barBg: 'rgba(30, 24, 16, 0.58)',
    barLine: 'rgba(255, 255, 255, 0.12)',
    barShadow: '0 14px 34px rgba(0, 0, 0, 0.55)',
    pillBg: 'rgba(245, 236, 219, 0.14)',
    pillLine: 'rgba(232, 176, 74, 0.24)',
    soonBg: 'rgba(245, 236, 219, 0.08)',
    soonText: '#ac9f86',
    soonLine: 'rgba(245, 236, 219, 0.16)',
    blush: '#2a2018',
    cardTint: 'rgba(246, 217, 143, 0.22)',
    cardGlow: 'rgba(232, 176, 74, 0.3)',
    fabDim: 'brightness(0.62) saturate(0.8)',
    scrim: 'rgba(0, 0, 0, 0.56)',
    aurora: 'radial-gradient(60% 45% at 8% 4%, rgba(232, 176, 74, 0.3), transparent 70%), radial-gradient(55% 45% at 96% 60%, rgba(200, 90, 70, 0.22), transparent 70%), radial-gradient(60% 40% at 40% 104%, rgba(90, 140, 120, 0.22), transparent 70%)',
    coinHi: '#fbe8b0',
    coinMid: '#e8b04a',
    coinLo: '#8a6a28',
    coinInk: '#2c1e06',
    coinGlow: 'rgba(232, 176, 74, 0.5)',
    reading: '#e58bb4',
    readingSoft: '#f3b9d2',
    readingGlow: 'rgba(229, 139, 180, 0.22)',
    readingRing: 'rgba(229, 139, 180, 0.55)',
    onReading: '#2a0a1c',
    warn: '#f0b35a',
    onWarn: '#2a1a04',
};
const light = {
    bg: '#f8f2e8',
    bgRaised: '#fbf7f0',
    surface: '#fffcf7',
    line: '#e6d9c9',
    text: '#211c18',
    muted: '#6e6258',
    mutedDim: '#85796e',
    accent: '#a47f4f',
    accentSoft: '#8a6a3f',
    accentDeep: '#d8c3a5',
    fill: '#33122f',
    fillSoft: '#5a1224',
    onFill: '#f7e6b8',
    fillGradient: 'linear-gradient(160deg, #5a1224, #33122f)',
    fillRing: '#c99a45',
    fillGlow: 'rgba(51, 18, 47, 0.42)',
    ok: '#3f8a63',
    danger: '#b8492f',
    glow: 'rgba(164, 127, 79, 0.18)',
    barBg: 'rgba(251, 247, 240, 0.78)',
    barLine: 'rgba(164, 127, 79, 0.2)',
    barShadow: '0 12px 30px rgba(33, 28, 24, 0.12)',
    pillBg: 'rgba(164, 127, 79, 0.12)',
    pillLine: 'rgba(164, 127, 79, 0.34)',
    soonBg: 'rgba(164, 127, 79, 0.08)',
    soonText: '#85796e',
    soonLine: 'rgba(164, 127, 79, 0.22)',
    blush: '#e4cec0',
    cardTint: 'rgba(228, 206, 192, 0.85)',
    cardGlow: 'rgba(164, 127, 79, 0.22)',
    fabDim: 'brightness(1.25) saturate(0.7)',
    scrim: 'rgba(46, 34, 26, 0.34)',
    aurora: 'radial-gradient(60% 45% at 8% 4%, rgba(232, 196, 120, 0.42), transparent 70%), radial-gradient(55% 45% at 96% 60%, rgba(214, 170, 150, 0.42), transparent 70%), radial-gradient(60% 40% at 40% 104%, rgba(150, 180, 160, 0.34), transparent 70%)',
    coinHi: '#f6dc9c',
    coinMid: '#c99a45',
    coinLo: '#7a5a26',
    coinInk: '#3a240c',
    coinGlow: 'rgba(201, 154, 69, 0.45)',
    reading: '#8a2f62',
    readingSoft: '#b5558c',
    readingGlow: 'rgba(138, 47, 98, 0.18)',
    readingRing: 'rgba(138, 47, 98, 0.5)',
    onReading: '#fbe9f3',
    warn: '#c97d1c',
    onWarn: '#fff6e6',
};
exports.themes = { dark, light };
exports.defaultTheme = 'dark';
exports.readingSheetTheme = 'light';
exports.colors = {
    ink: dark.bgRaised,
    surface: dark.bg,
    surfaceAlt: dark.surface,
    text: dark.text,
    textMuted: dark.muted,
    gold: dark.accent,
    goldSoft: dark.accentDeep,
    accent: dark.accentDeep,
    success: dark.ok,
    danger: dark.danger,
};
exports.fonts = {
    display: '"Playfair Display", Georgia, "Times New Roman", serif',
    body: '"Jost", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    mono: 'ui-monospace, Menlo, Consolas, monospace',
    googleFamilies: 'family=Playfair+Display:ital,wght@0,500;1,500;1,600&family=Jost:wght@300;400;500',
};
exports.spacing = {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 40,
    xxl: 64,
};
exports.radii = {
    sm: 8,
    field: 14,
    md: 16,
    lg: 24,
    panel: 28,
    bar: 36,
    arch: 70,
    archBase: 8,
    full: 9999,
};
exports.typography = {
    fontStack: exports.fonts.body,
    displayStack: exports.fonts.display,
    sizes: { xs: 12, sm: 14, md: 16, lg: 20, xl: 28, display: 44 },
    weights: { light: 300, regular: 400, medium: 500 },
    eyebrowTracking: '0.24em',
};
exports.motion = {
    navLeadBase: 0.2,
    navLeadPerPx: 1 / 2400,
    navLeadMaxDistance: 500,
    navTrailDelay: 0.05,
    navTrailExtra: 0.05,
    navSquash: 3,
    navEase: 'cubic-bezier(0.2, 0.8, 0.3, 1)',
    navGrow: 2.3,
    navGrowMs: 400,
    navLabelPx: 12,
    themeFadeMs: 300,
    screenMs: 320,
    screenShift: 28,
    screenEase: 'cubic-bezier(0.2, 0.8, 0.3, 1)',
};
exports.soon = {
    label: 'Скоро',
    disabledOpacity: 0.45,
};
var brand_1 = require("./brand");
Object.defineProperty(exports, "brandMark", { enumerable: true, get: function () { return brand_1.brandMark; } });
Object.defineProperty(exports, "brandColors", { enumerable: true, get: function () { return brand_1.brandColors; } });
Object.defineProperty(exports, "brandWordmark", { enumerable: true, get: function () { return brand_1.brandWordmark; } });
Object.defineProperty(exports, "brandBeta", { enumerable: true, get: function () { return brand_1.brandBeta; } });
//# sourceMappingURL=index.js.map